import { Tooltip } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { ReactComponent as RecurringIcon } from "assets/icons/clockWise_refresh.svg";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Arrow from "assets/icons/Arrow-down-gray-png.png";
import { CheckBox } from "components/CheckBox/CheckBox";
import { Counter } from "components/Counter/Counter";
import { InputField } from "components/InputField/InputField";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formSlice } from "services/api/forms";
import { SolidLine } from "../Thems";

import { getCurrency, numberFormat } from "helper/numberFormat";
import {
  Amount,
  AmountField,
  AmountSign,
  FirstDiv,
  FlexItem,
  FlexItemsContainer,
  ProductContent,
  SecondDiv,
  SelectWrapper,
  Title,
  VarientAmount,
  Wrapper
} from "./Thems";
import { getAuthenticated } from "utils/functions";
import { Fonts, FontColors } from "theme/fontConfig";

const useStyles = makeStyles(() => ({
  formControl: {
    "& .MuiInputBase-root": {
      display: "flex",
      justifyContent: "left",
      width: "100%",
      border: 0,
      marginTop: "10px"
    },

    "& .MuiSelect-select.MuiSelect-select": {
      paddingRight: "0px"
    }
  },
  select: {
    display: "flex",
    justifyContent: "left",
    width: "100% !importent",
    fontSize: Fonts.GeneralCaptionFont.fontSize,

    "&:focus": {
      border: 0
    },
    "&:hover": {
      border: 0
    }
  },
  selectIcon: {
    position: "relative",
    color: FontColors.Blue002E5C,
    fontSize: "14px",
    opacity: 0.4
  },
  paper: {
    borderRadius: 12,
    marginTop: 8
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
    "& li": {
      fontWeight: Fonts.GeneralCaptionFont.fontWeight,
      paddingTop: 8,
      paddingBottom: 8,
      fontSize: Fonts.GeneralCaptionFont.fontSize
    },
    "& li.Mui-selected": {
      color: FontColors.Blue002E5C,
      background: "##F4F6F9"
    },
    "& li.Mui-selected:hover": {
      background: "##F4F6F9"
    }
  }
}));

export const Products = React.memo(
  ({
    productsData,
    index,
    incrementCounter,
    decrementCounter,
    formik,
    ticketUniqueId,
    totalProducts,
    handleTotalForPay
  }) => {
    const isAuthenticated = getAuthenticated();
    const isAuth =
      localStorage.getItem("memberPortal") === "true" ? isAuthenticated : false;
    const [amountErrors, setAmountErrors] = useState({});
    const [editingAmount, setEditingAmount] = useState({});
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
    useEffect(() => {
      const handler = () => setIsDesktop(window.innerWidth > 768);
      window.addEventListener("resize", handler);
      return () => window.removeEventListener("resize", handler);
    }, []);
    const { varients, selectedValue } = useSelector(state => state?.Forms);
    const [newData, setNewData] = useState([]);
    const dispatch = useDispatch();
    const formDataReservation = formik?.values?.registrationForm || [];
    const classes = useStyles();
    useEffect(() => {
      if (!productsData?.length) return;

      productsData.forEach((p, i) => {
        if (p.type === "optional" && p.isRequired && p.counter === 0) {
          incrementCounter(p._id, p, 0, i);

          // only add price if NO variant
          if (!p.variant) {
            handleSelect(1, ticketUniqueId, i, null, null, p);
          }
        }
      });
    }, [productsData]);
    const currency = getCurrency();
    const totalPay = handleTotalForPay();

    const menuProps = {
      classes: {
        list: classes.list,
        paper: classes.paper
      },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      getContentAnchorEl: null
    };

    const handleSelect = (
      e,
      ticketIndex,
      productIndex,
      dropdownIndex,
      dropdownObj,
      product
    ) => {
      const varientAmount = product.variantInfo?.filter(
        val => val.option === e.target?.value
      );
      const isOpenAmountVariant = Boolean(varientAmount?.[0]?.openAmount);
      const resolvedVariantPrice = isOpenAmountVariant
        ? varientAmount?.[0]?.minimumOpenAmount || 0
        : varientAmount?.[0]?.price || varientAmount?.[0]?.amount || 0;
      console.log("selectedValue1", varientAmount, product.variantInfo);
      // find if the selected object include the array of selected items or not
      const selectedValueIndex = selectedValue?.map(item => {
        if (product.variant && dropdownIndex) {
          return item[product.title]?.find(
            item =>
              item.indexSelected === dropdownIndex &&
              item.ticketIndex === ticketIndex
          );
        } else {
          return item[product.title]?.find(
            item => item.ticketIndex === ticketIndex
          );
        }
      });

      console.log("selectedValue1", selectedValueIndex, selectedValue);
      // Crete array of objects for dropDown selected values ,if data exist update the object
      // Update
      if (
        // !isOpenAmountVariant &&
        selectedValueIndex?.length > 0 &&
        selectedValueIndex[0] !== undefined
      ) {
        const newArray = [...selectedValue];
        const newData = newArray[0][product.title]?.map((item, index) => {
          if (!product.variant && !dropdownIndex) {
            if (item.ticketIndex === selectedValueIndex[0].ticketIndex) {
              if (e !== 0 && product.type === "openAmount") {
                return {
                  value: e,
                  ticketIndex: item.ticketIndex,
                  amount: product?.amount,
                  productId: product?._id,
                  price: item?.price,
                  type: item?.type
                };
              } else {
                return {
                  value: e,
                  ticketIndex: item.ticketIndex,
                  amount: product?.amount,
                  productId: product?._id,
                  type: item?.type
                };
              }
            } else {
              return { ...item };
            }
          } else {
            if (
              // item.indexSelected === selectedValueIndex[0].indexSelected &&
              // item.ticketIndex === selectedValueIndex[0].ticketIndex
              item.indexSelected === dropdownIndex &&
              item.ticketIndex === ticketIndex &&
              item.productId === product._id
            ) {
              return {
                value: e.target?.value,
                indexSelected: dropdownIndex,
                previousValue: item.value, // Capture old value so reducer decrements old variant's counter
                ticketIndex: ticketIndex,
                amount: resolvedVariantPrice,
                price: resolvedVariantPrice,
                productId: product?._id,
                type: product?.type
              };
            } else {
              return { ...item };
            }
          }
        });

        const data = [{ ...newArray[0], [product.title]: [...newData] }];
        dispatch(
          formSlice.actions.setSelectedValue({
            data: data,
            productIndex: productIndex,
            productTitle: product.title,
            dropdownIndex: dropdownIndex,
            type: "",
            ticketIndex: ticketIndex
          })
        );
      }
      // Add new
      else if (!selectedValueIndex?.[0]) {
        let newArray = selectedValue ? [...selectedValue] : [];
        if (newArray?.length === 0) {
          // if the array empty , in the first select we don't have selected value
          if (!product.variant && !dropdownIndex) {
            // For openAmount products, e is the entered amount
            const enteredAmount = e;
            newArray.push({
              [product.title]: [
                {
                  value: enteredAmount,
                  ticketIndex: ticketIndex,
                  amount: product?.amount,
                  price: enteredAmount, // Set price to entered amount for openAmount
                  productId: product?._id,
                  type: product?.type
                }
              ]
            });
          } else {
            newArray.push({
              [product.title]: [
                {
                  value: e.target?.value,
                  indexSelected: dropdownIndex,
                  previousValue: "",
                  ticketIndex: ticketIndex,
                  amount: resolvedVariantPrice,
                  price: resolvedVariantPrice,
                  productId: product?._id,

                  type: product?.type
                }
              ]
            });
          }
          dispatch(
            formSlice.actions.setSelectedValue({
              data: newArray,
              productIndex: productIndex,
              productTitle: product.title,
              dropdownIndex: dropdownIndex,
              type: "",
              ticketIndex: ticketIndex
            })
          );
        } else if (!Object.keys(newArray[0]).includes(product.title)) {
          //if the obj name doesn't exist , we don't have selected value becuse it's new product with new drop and there is no previousValue
          if (!product.variant && !dropdownIndex) {
            // For openAmount products, e is the entered amount
            const enteredAmount = e;
            const data = [
              {
                ...newArray[0],
                [product.title]: [
                  {
                    value: enteredAmount,
                    ticketIndex: ticketIndex,
                    amount: product?.amount,
                    price: enteredAmount, // Set price to entered amount for openAmount
                    productId: product?._id,
                    type: product?.type
                  }
                ]
              }
            ];
            dispatch(
              formSlice.actions.setSelectedValue({
                data: data,
                productIndex: productIndex,
                productTitle: product.title,
                dropdownIndex: null,
                type: "",
                ticketIndex: ticketIndex
              })
            );
          } else {
            console.log("selectedValue1", newArray, data, varientAmount);
            const data = [
              {
                ...newArray[0],
                [product.title]: [
                  {
                    value: e.target?.value,
                    indexSelected: dropdownIndex,
                    previousValue: "",
                    ticketIndex: ticketIndex,
                    amount: resolvedVariantPrice,
                    price: resolvedVariantPrice,
                    productId: product?._id,
                    type: product?.type
                  }
                ]
              }
            ];

            dispatch(
              formSlice.actions.setSelectedValue({
                data: data,
                productIndex: productIndex,
                productTitle: product.title,
                dropdownIndex: dropdownIndex,
                type: "",
                ticketIndex: ticketIndex
              })
            );
          }
        } else {
          let data;
          // if the obj name are exist we need to add inside it
          if (!product.variant && !dropdownIndex) {
            data = [
              {
                ...newArray[0],
                [product.title]: [
                  ...newArray[0][product.title],
                  {
                    value: e,
                    ticketIndex: ticketIndex,
                    amount: product?.amount,
                    productId: product?._id,
                    type: product?.type
                  }
                ]
              }
            ];
          } else {
            const items = newArray[0][product.title] || [];

            const exists = items.some(
              item =>
                item.indexSelected === dropdownIndex &&
                item.ticketIndex === ticketIndex &&
                item.productId === product._id
            );

            data = [
              {
                ...newArray[0],
                [product.title]: exists
                  ? items // ✅ already exists → DO NOTHING
                  : [
                      ...items,
                      {
                        value: e.target?.value,
                        indexSelected: dropdownIndex,
                        previousValue: "",
                        ticketIndex: ticketIndex,
                        amount: resolvedVariantPrice,
                        price: resolvedVariantPrice,
                        productId: product?._id,
                        type: product?.type
                      }
                    ]
              }
            ];
            // data = [
            //   {
            //     ...newArray[0],
            //     [product.title]: [
            //       ...newArray[0][product.title],
            //       {
            //         value: e.target?.value,
            //         indexSelected: dropdownIndex,
            //         previousValue: "",
            //         ticketIndex: ticketIndex,
            //         amount: varientAmount?.[0]?.amount,
            //           price: varientAmount?.[0]?.price || varientAmount?.[0]?.amount,
            //         productId: product?._id,
            //         type: product?.type,
            //       },
            //     ],
            //   },
            // ];
          }
          dispatch(
            formSlice.actions.setSelectedValue({
              data: data,
              productIndex: productIndex,
              productTitle: product.title,
              dropdownIndex: dropdownIndex,
              type: "",
              ticketIndex: ticketIndex
            })
          );
        }
      }

      if (product.variant) {
        // add selected value to varient

        formik.setFieldValue(
          `ticketsData.[${index}].[${productIndex}].dropdowns[${dropdownIndex}]`,
          {
            ...dropdownObj,
            selectedValue: e.target?.value,
            amount: varientAmount?.[0]?.amount,
            price: varientAmount?.[0]?.price || varientAmount?.[0]?.amount
          }
        );
      }
    };
    //     useEffect(() => {
    //       const newArr = [];
    //       // Handle product data inside the local storage
    //       if (selectedValue !== undefined && selectedValue?.length !== 0) {
    //         const Data =
    //           selectedValue &&
    //           Object.keys(selectedValue[0]).map((key) => {
    //             const formatData = selectedValue[0][key]?.map((item) => {

    //               if (item.ticketIndex === ticketUniqueId) {

    //                 if (item.hasOwnProperty("indexSelected")) {
    //                   const isExistObj = newArr.find((item) => item?.title === key);
    //                   const findProductIndex = newArr.findIndex(
    //                     (product) => product.title === key
    //                   );
    //                   // if (isExistObj && isExistObj !== undefined) {
    //                   //   if (
    //                   //     newArr[findProductIndex]?.variant?.hasOwnProperty(
    //                   //       item.value
    //                   //     )
    //                   //   ) {
    //                   //     newArr[findProductIndex].variant[item.value] =
    //                   //       newArr[findProductIndex].variant[item.value] + 1;
    //                   //   } else {
    //                   //     newArr[findProductIndex].variant[item.value] = 1;
    //                   //   }
    //                   // }
    //                   if (isExistObj && isExistObj !== undefined) {
    //   newArr[findProductIndex].quantity =
    //     (newArr[findProductIndex].quantity || 0) + 1;

    //   const price = item?.price || item?.amount || 0;

    //   newArr[findProductIndex].amount =
    //     (newArr[findProductIndex].amount || 0) + price;
    // }
    //                    else {
    //       //               newArr.push({
    //       //                 id: item?.productId,
    //       //                 title: key,
    //       //                 variant: {
    //       //                     quantity: 1,
    //       // price: item?.price || item?.amount || 0
    //       //                 },
    //       //               });
    //      newArr.push({
    //   id: item?.productId,
    //   title: key,
    //   quantity: 1,
    //   price: item?.price || item?.amount || 0,
    //   amount: item?.price || item?.amount || 0,
    // });
    //                   }
    //                 } else {
    //                   // check if we have type openAmount to add price to object
    //                   const productType = productsData?.filter(
    //                     (val) => val._id === item.productId
    //                   )[0];

    //                   if (item.value !== 0 && productType?.type === "openAmount") {

    //                     // newArr.push({
    //                     //   id: item?.productId,
    //                     //   title: key,
    //                     //   quantity: item.value,
    //                     //   price: item?.price,
    //                     // });
    //                     newArr.push({
    //   id: item?.productId,
    //   title: key,
    //   quantity: item.value,
    //   price: item?.price,
    //   amount: item?.price,
    // });
    //                   } else {
    //                     newArr.push({
    //                       id: item?.productId,
    //                       title: key,
    //                       quantity: item.value,
    //                     });
    //                   }
    //                 }
    //                 setNewData(newArr);
    //               }
    //             });
    //           });
    //       }
    //     }, [productsData, selectedValue, ticketUniqueId]);

    ///fixed till here now only the number is of tshirt is coming wrong on update of input and select
    useEffect(() => {
      const newArr = [];

      if (selectedValue && selectedValue.length !== 0) {
        Object.keys(selectedValue[0]).forEach(key => {
          const items = (selectedValue[0][key] || []).filter(
            (item, index, self) =>
              index ===
              self.findIndex(
                i =>
                  i.productId === item.productId &&
                  i.ticketIndex === item.ticketIndex &&
                  i.indexSelected === item.indexSelected
              )
          );

          items.forEach(item => {
            if (item.ticketIndex !== ticketUniqueId) return;

            const isVariant = item.hasOwnProperty("indexSelected");
            const quantity = isVariant ? 1 : item.value || 0;
            const price = item?.price || item?.amount || 0;

            if (quantity === 0 && price === 0) return; // Skip items with 0 quantity and 0 price

            // Use productId+ticketIndex to group all variants of same product
            const identityKey = `${item.productId}-${item.ticketIndex}`;

            const existingIndex = newArr.findIndex(
              el => el._key === identityKey
            );

            // Look up installment info from varients
            const varientEntry = Object.values(varients || {}).find(
              v => v.id === item.productId
            );
            const installmentInfo = varientEntry?.installmentStatus
              ? varientEntry?.installment
              : null;

            const productEntry = {
              _key: identityKey,
              id: item.productId,
              title: key,
              quantity: quantity,
              price: price
            };

            // Add numberOfInstallments if product has installments
            if (installmentInfo?.value) {
              productEntry.numberOfInstallments = installmentInfo.value;
            }

            if (isVariant) {
              const variantOptionName = item.value;
              const variantOptionInfo = varientEntry?.variantsInfo?.find(v => v.option === variantOptionName);
              const isOpenAmountVariant = Boolean(variantOptionInfo?.openAmount) || varientEntry?.limitType === "amount";
              const variantPrice = isOpenAmountVariant
                ? (variantOptionInfo?.price ?? variantOptionInfo?.amount ?? variantOptionInfo?.minimumOpenAmount ?? 0)
                : undefined;

              if (existingIndex !== -1) {
                const existingVariant = newArr[existingIndex].variant || {};
                const prevCount = typeof existingVariant[variantOptionName] === "object"
                  ? (existingVariant[variantOptionName]?.title ?? 0)
                  : (existingVariant[variantOptionName] ?? 0);
                newArr[existingIndex] = {
                  ...newArr[existingIndex],
                  quantity: newArr[existingIndex].quantity + quantity,
                  variant: {
                    ...existingVariant,
                    [variantOptionName]: isOpenAmountVariant
                      ? { quantity: prevCount + 1, price: variantPrice }
                      : { quantity: prevCount + 1 }
                  }
                };
              } else {
                newArr.push({
                  ...productEntry,
                  price: undefined,
                  variant: {
                    [variantOptionName]: isOpenAmountVariant
                      ? { quantity: 1, price: variantPrice }
                      : { quantity: 1 }
                  }
                });
              }
            } else {
              // For simple products: { id, title, quantity, price }
              if (existingIndex !== -1) {
                newArr[existingIndex] = {
                  ...newArr[existingIndex],
                  quantity: quantity,
                  price: price
                };
              } else {
                newArr.push(productEntry);
              }
            }
          });
        });
      }

      // Enrich open-amount products with the user-entered price from productsOpenAmount
      // (selectedValue only stores the initial/minimum price, not the user-edited value)
      newArr.forEach((item) => {
        if (item.variant) return; // variant open-amount price is already inside variant object
        const productDef = productsData?.find((p) => p._id === item.id);
        if (productDef?.type === "openAmount" || productDef?.openAmount) {
          const productIndex = productsData?.findIndex((p) => p._id === item.id);
          const enteredPrice = Number(formik?.values?.productsOpenAmount?.[productIndex] ?? productDef?.minimumOpenAmount ?? 0);
          if (enteredPrice > 0) item.price = enteredPrice;
        }
      });

      const cleanedData = newArr
        .filter(item => item.quantity !== 0 || item.price !== 0 || item.variant)
        .map(({ _key, price, ...rest }) => price !== undefined ? { price, ...rest } : rest);

      setNewData(cleanedData);
    }, [selectedValue, ticketUniqueId, varients, formik?.values?.productsOpenAmount]);

    useEffect(() => {
      let newArray = newData?.filter(item => item.quantity !== 0);
      let result = {};
      newArray.forEach(item => {
        result[item.title] = item;
      });
      const currentTicketIndex = formDataReservation?.findIndex(
        item => item.id === ticketUniqueId
      );
      const formDataReservationCopy = [...formDataReservation];

      if (currentTicketIndex !== -1) {
        formDataReservationCopy[currentTicketIndex] = {
          ...formDataReservationCopy[currentTicketIndex],
          products:
            newData.length === 1 && newData[0]?.quantity === 0
              ? []
              : [...newArray]
        };
        formik.setFieldValue(`registrationForm`, formDataReservationCopy);
      }
    }, [newData]);

    const regex = /([1-9]*[\.|\,]{0,1}[1-9]{0,2})/s;

    const addPriceToObjects = useCallback(
      (e, id, title) => {
        const { value } = e.target;
        console.log(
          "value.match(regex)[0]",
          value,
          value.match(regex)[0],
          value === "" && value.match(regex)[0]
        );

        if (!regex.test(value) && (value !== "" || value !== 0)) {
          return;
        }
        formik.setFieldValue("totalPayment", value.match(regex)[0]);
        let data;
        const selectedValueIndex = selectedValue?.[0]?.[title]?.map(item => {
          return { ...item, price: value };
        });
        data = [
          {
            ...selectedValue[0],
            [title]: [
              { ...selectedValue[0]?.[title]?.[0], price: Number(value) }
            ]
          }
        ];
        console.log("selectedValue1", data, value.match(regex)[0]);
        dispatch(
          formSlice.actions.setSelectedValue({
            data: data,
            productIndex: id,
            productTitle: title,
            dropdownIndex: null,
            type: "",
            ticketIndex: null
          })
        );

        const addPrice = Object.values(varients).map(el =>
          el.id === id ? { ...el, price: Number(value) } : el
        );

        dispatch(formSlice.actions.setVarients(addPrice));
      },
      [formik]
    );

    const preventMinus = (e, value) => {
      if ((e.code === "Numpad0" || e.code === "Digit0") && value === "")
        e.preventDefault();
      if (
        e.code === "NumpadSubtract" ||
        e.code === "Minus" ||
        e.code === "Equal" ||
        e.code === "KeyE" ||
        e.code === "NumpadAdd"
      ) {
        e.preventDefault();
      }
    };

    const sortedProductIndexes = React.useMemo(() => {
      if (!productsData) return [];

      return productsData
        .map((p, i) => ({
          index: i,
          type: p.type,
          isRequired: p.isRequired
        }))
        .sort((a, b) => {
          const getPriority = p => {
            if (p.type === "onRegistration") return 1;
            if (p.isRequired) return 2;
            return 3;
          };

          return getPriority(a) - getPriority(b);
        })
        .map(item => item.index);
    }, [productsData]);

    return (
      <Wrapper>
        {sortedProductIndexes?.map(productIndex => {
          const product = productsData[productIndex];
          const minAmountProduct = product?.minimumOpenAmount || 0;

          // const minAmountProduct=20;
          const reserveProduct = product?.reserveProduct || 0;
          const rawCapacity = varients?.[productIndex]?.varientCapacity;
          const effectiveCapacity =
            rawCapacity === "noLimit" || rawCapacity === undefined
              ? "noLimit"
              : Math.max(0, rawCapacity - reserveProduct);
          const isAddonSoldOut =
            effectiveCapacity !== "noLimit" && effectiveCapacity <= 0;
          return (
            <>
              <ProductContent
                style={{
                  background: "#F4F6F9",
                  padding: "16px",
                  borderRadius: "10px",
                  marginBottom: "12px",
                  display: product?.type === "openAmount" ? "flex" : "",
                  flexDirection:
                    product?.type === "openAmount" && isDesktop
                      ? "row"
                      : ""
                }}
              >
                <FirstDiv
                  totalProducts={
                    totalPay?.total !== "0.00" || totalProducts > 0
                  }
                >
                  <FlexItemsContainer
                    sx={{
                      justifyContent: "space-between",
                      flexDirection: { xs: "column", md: "row" }
                    }}
                  >
                    <FlexItem>
                      {product?.type === "openAmount" ? (
                        <CheckBox
                          text={
                            <span style={{ fontSize: Fonts.GeneralLargeBodyFont.fontSize, display: "inline-flex", alignItems: "center", gap: 4 }}>
                              {product?.title}
                              {product?.isRecurring && (
                                <Tooltip title="Monthly recurring" placement="top">
                                  <span style={{ display: "inline-flex", alignItems: "center", cursor: "pointer", padding: "7px 9px", backgroundColor: "rgba(37, 85, 239, 0.13)", borderRadius: "6px" }}>
                                    <RecurringIcon width={9} height={9} />
                                  </span>
                                </Tooltip>
                              )}
                            </span>
                          }
                          // text={product?.title}
                          checked={product?.counter > 0}
                          noFont={true}
                          onChange={e => {
                            if (e.target.checked) {
                              incrementCounter(
                                product?._id,
                                product,
                                product?.counter,
                                productIndex
                              );
                              formik.setFieldValue(
                                `productsOpenAmount.${productIndex}`,
                                minAmountProduct
                              );
                              if (minAmountProduct) {
                                dispatch(
                                  formSlice.actions.setVarientPrice({
                                    productIndex,
                                    price: Number(minAmountProduct)
                                  })
                                );
                              }
                              handleSelect(
                                product?.counter + 1,
                                ticketUniqueId,
                                productIndex,
                                null,
                                null,
                                product
                              );
                            } else {
                              decrementCounter(
                                product?._id,
                                product,
                                product?.counter,
                                productIndex
                              );
                              handleSelect(
                                0,
                                ticketUniqueId,
                                productIndex,
                                null,
                                null,
                                product
                              );
                            }
                          }}
                        />
                      ) : product?.limitType === "checkbox" ? (
                        <CheckBox
                          noFont={true}
                          text={
                            <span style={{ fontSize: Fonts.GeneralLargeBodyFont.fontSize, display: "inline-flex", alignItems: "center", gap: 4 }}>
                              {product?.title}
                              {product?.isRecurring && (
                                <Tooltip title="Monthly recurring" placement="top">
                                  <span style={{ display: "inline-flex", alignItems: "center", cursor: "pointer", padding: "7px 9px", backgroundColor: "rgba(37, 85, 239, 0.13)", borderRadius: "6px" }}>
                                    <RecurringIcon width={9} height={9} />
                                  </span>
                                </Tooltip>
                              )}
                              {product?.isRequired && (
                                <span style={{ color: FontColors.Red }}> *</span>
                              )}
                            </span>
                          }
                          onChange={e => {
                            if (e.target.checked) {
                              incrementCounter(
                                product?._id,
                                product,
                                product?.counter,
                                productIndex
                              );
                              !product?.variant &&
                                handleSelect(
                                  product?.counter + 1,
                                  ticketUniqueId,
                                  productIndex,
                                  null,
                                  null,
                                  product,
                                  product?.title
                                );
                            } else {
                              decrementCounter(
                                product?._id,
                                product,
                                product?.counter,
                                productIndex
                              );
                              !product?.variant &&
                                handleSelect(
                                  product?.counter - 1,
                                  ticketUniqueId,
                                  productIndex,
                                  null,
                                  null,
                                  product,
                                  product?.title
                                );
                            }
                          }}
                          checked={product?.counter > 0}
                        />
                      ) : (
                        <Title style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                          {product?.title}
                          {product?.isRecurring && (
                            <Tooltip title="Monthly recurring" placement="top">
                              <span style={{ display: "inline-flex", alignItems: "center", cursor: "pointer", padding: "7px 9px", backgroundColor: "rgba(37, 85, 239, 0.13)", borderRadius: "6px" }}>
                                <RecurringIcon width={9} height={9} />
                              </span>
                            </Tooltip>
                          )}
                          {(product?.isRequired ||
                            product?.type === "onRegistration") ? (
                            <span style={{ color: FontColors.Red }}> *</span>
                          ) : null}
                        </Title>
                      )}

                      {/* {product?.limitType === "checkbox" ? (
                        <CheckBox
                          text={product?.title}
                          onChange={(e) => {
                            if (e.target.checked) {
                              incrementCounter(
                                product._id,
                                product,
                                product?.counter,
                                productIndex
                              );
                              !product.variant &&
                                handleSelect(
                                  product?.counter + 1,
                                  ticketUniqueId,
                                  productIndex,
                                  null,
                                  null,
                                  product,
                                  product?.title
                                );
                            } else {
                              decrementCounter(
                                product._id,
                                product,
                                product?.counter,
                                productIndex
                              );
                              !product.variant &&
                                handleSelect(
                                  product?.counter - 1,
                                  ticketUniqueId,
                                  productIndex,
                                  null,
                                  null,
                                  product,
                                  product?.title
                                );
                            }
                          }}
                          checked={product?.counter > 0}
                          // disabled={
                          //   varients?.[productIndex]?.varientCapacity !==
                          //     "noLimit" &&
                          //   (varients?.[productIndex]?.varientCapacity ===
                          //     varients?.[productIndex]?.numberOfDrops ||
                          //     varients?.[productIndex]?.varientCapacity ===
                          //       varients?.[productIndex]?.counterValue)
                          // }
                        />
                      ) : (
                        <Title>{product?.title}{product.isRequired?<span style={{color:"red"}}> *</span>:<></>}</Title>
                      )} */}
                    </FlexItem>
                    <FlexItem>
                      {product?.limitType === "checkbox" && !product?.variant ? (
                        <span style={{ fontWeight: Fonts.GeneralLabelFont.fontWeight, fontSize: Fonts.GeneralLabelFont.fontSize, whiteSpace: "nowrap" }}>
                          {numberFormat({ number: product?.amount, decimal: 2, style: "currency" })}
                        </span>
                      ) : product?.limitType !== "checkbox" &&
                        product?.type !== "openAmount" &&
                        product?.type !== "onRegistration" && (
                          <Counter
                            key={product._id}
                            width={"100%"}
                            product={product}
                            counter={product?.counter}
                            handleClickIncrement={() => {
                              incrementCounter(
                                product._id,
                                product,
                                product?.counter,
                                productIndex
                              );
                              !product.variant &&
                                handleSelect(
                                  product?.counter + 1,
                                  ticketUniqueId,
                                  productIndex,
                                  null,
                                  null,
                                  product,
                                  product?.title
                                );
                            }}
                            handleClickDecrement={() => {
                              if (
                                product?.counter > (product?.isRequired ? 1 : 0)
                              ) {
                                decrementCounter(
                                  product._id,
                                  product,
                                  product?.counter,
                                  productIndex
                                );
                                !product.variant &&
                                  handleSelect(
                                    product?.counter - 1,
                                    ticketUniqueId,
                                    productIndex,
                                    null,
                                    null,
                                    product,
                                    product?.title
                                  );
                              }
                            }}
                            disabled={
                              isAddonSoldOut ||
                              (effectiveCapacity !== "noLimit" &&
                                (effectiveCapacity <=
                                  varients?.[productIndex]?.numberOfDrops ||
                                  effectiveCapacity <=
                                    varients?.[productIndex]?.counterValue))
                            }
                          />
                        )}
                    </FlexItem>
                  </FlexItemsContainer>
                </FirstDiv>

                <SecondDiv>
                  {(product?.counter > 0 ||
                    product?.type === "onRegistration") &&
                    product?.variant && (
                      <FormControl fullWidth className={classes.formControl}>
                        {// product?.dropdowns?.map((dropdown, dropdownIndex)
                        (product?.dropdowns?.length
                          ? product.dropdowns
                          : product.type === "onRegistration"
                          ? [{}]
                          : []
                        ).map((dropdown, dropdownIndex) => {
                          const selectedVariant = varients?.[
                            productIndex
                          ]?.variantsInfo?.find(
                            v => v.option === dropdown?.selectedValue
                          );

                          // const isVariantOpenAmount=false;
                          const isVariantOpenAmount =
                            selectedVariant?.openAmount;
                          const minAmount =
                            selectedVariant?.minimumOpenAmount ||
                            product?.minAmount ||
                            0;

                          return (
                            <>
                              {" "}
                              <SelectWrapper thereIsAmount={dropdown.amount}>
                                {isVariantOpenAmount ? (
                                  <div style={{ display: "flex", flexDirection: "column", width: "130px", flexShrink: 0, marginTop: 8 }}>
                                    {editingAmount[`${productIndex}-${dropdownIndex}`] ? (
                                      <div style={{ position: "relative", width: "100%", height: 48 }}>
                                        <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: Fonts.GeneralSubHeaderFont.fontSize, fontWeight: Fonts.GeneralSubHeaderFont.fontWeight, color: FontColors.Blue2555EF, pointerEvents: "none" }}>
                                          {currency}
                                        </span>
                                        <input
                                          autoFocus
                                          type="number"
                                          value={dropdown?.price ?? (selectedVariant?.minimumOpenAmount || 0)}
                                          onChange={e => {
                                            const value = Number(e.target.value);
                                            if (value > 1000000) return;
                                            formik.setFieldValue(`ticketsData.[${index}].[${productIndex}].dropdowns[${dropdownIndex}].price`, value);
                                            if (value < minAmount) {
                                              setAmountErrors(prev => ({ ...prev, [`${productIndex}-${dropdownIndex}`]: `Minimum amount is ${minAmount}` }));
                                            } else {
                                              setAmountErrors(prev => ({ ...prev, [`${productIndex}-${dropdownIndex}`]: "" }));
                                            }
                                            const updatedVariants = {
                                              ...varients,
                                              [productIndex]: {
                                                ...varients?.[productIndex],
                                                variantsInfo: varients?.[productIndex]?.variantsInfo?.map(v =>
                                                  v.option === dropdown?.selectedValue ? { ...v, price: value, amount: value } : v
                                                )
                                              }
                                            };
                                            dispatch(formSlice.actions.setVarients(updatedVariants));
                                            const existingItems = selectedValue?.[0]?.[product.title] || [];
                                            const key = `${product._id}-${ticketUniqueId}-${dropdownIndex}`;
                                            const normalized = existingItems.map(item => ({ ...item, _key: item._key || `${item.productId}-${item.ticketIndex}-${item.indexSelected}` }));
                                            const existsIndex = normalized.findIndex(item => item._key === key);
                                            const finalItems = existsIndex !== -1
                                              ? normalized.map((item, i) => i === existsIndex ? { ...item, amount: value, price: value, previousValue: item.value } : item)
                                              : [...normalized, { _key: key, value: dropdown?.selectedValue, previousValue: dropdown?.selectedValue, indexSelected: dropdownIndex, ticketIndex: ticketUniqueId, amount: value, price: value, productId: product._id, type: product?.type }];
                                            const cleanedItems = finalItems.map(({ _key, ...rest }) => rest);
                                            dispatch(formSlice.actions.setSelectedValue({ data: [{ ...(selectedValue?.[0] || {}), [product.title]: cleanedItems }], productIndex, productTitle: product.title, dropdownIndex, type: "", ticketIndex: ticketUniqueId }));
                                          }}
                                          onKeyDown={e => { if (e.key === "Enter") e.target.blur(); preventMinus(e, e.target.value); }}
                                          onBlur={e => {
                                            setEditingAmount(prev => ({ ...prev, [`${productIndex}-${dropdownIndex}`]: false }));
                                          }}
                                          style={{ width: "100%", height: 48, boxSizing: "border-box", border: "2px solid #2555EF", borderRadius: 12, paddingLeft: 34, paddingRight: 14, fontSize: Fonts.GeneralSubHeaderFont.fontSize, fontWeight: Fonts.GeneralSubHeaderFont.fontWeight, color: FontColors.Blue002E5C, background: "#fff", outline: "none", textAlign: "right", boxShadow: "0 2px 12px rgba(37,85,239,0.12)", WebkitAppearance: "none", appearance: "none" }}
                                        />
                                      </div>
                                    ) : (
                                      <div
                                        onClick={() => setEditingAmount(prev => ({ ...prev, [`${productIndex}-${dropdownIndex}`]: true }))}
                                        style={{ display: "flex", alignItems: "center", justifyContent: "space-between", background: "#fff", borderRadius: 12, padding: "11px 14px", cursor: "pointer", boxShadow: "0 2px 8px rgba(37,85,239,0.08)" }}
                                      >
                                        <span style={{ fontSize: Fonts.GeneralSmallHeaderFont.fontSize, fontWeight: Fonts.GeneralSmallHeaderFont.fontWeight, color: FontColors.Blue002E5C }}>
                                          {currency}{Number(dropdown?.price ?? (selectedVariant?.minimumOpenAmount || 0)).toFixed(2)}
                                        </span>
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#2555EF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                                        </svg>
                                      </div>
                                    )}
                                    {amountErrors[`${productIndex}-${dropdownIndex}`] && (
                                      <div style={{ color: FontColors.Red, fontSize: Fonts.GeneralCaptionFont.fontSize, marginTop: 4 }}>{amountErrors[`${productIndex}-${dropdownIndex}`]}</div>
                                    )}
                                  </div>
                                ) : (
                                  <VarientAmount>
                                    {" "}
                                    {dropdown.amount
                                      ? `${numberFormat({
                                          number: dropdown.amount,
                                          decimal: 2,
                                          style: "currency"
                                        })}`
                                      : ""}
                                  </VarientAmount>
                                )}
                                <Select
                                  // style={{ width: "300px", backgroundColor: '#fff', borderRadius:'6px' }}
                                  sx={{
                                    maxWidth: {
                                      xs: "100%",
                                      md: "300px",
                                      lg: "300px"
                                    },
                                    backgroundColor: "#fff",
                                    borderRadius: "6px"
                                  }}
                                  displayEmpty
                                  onChange={e => {
                                    handleSelect(
                                      e,
                                      ticketUniqueId,
                                      productIndex,
                                      dropdownIndex,
                                      dropdown,
                                      product,
                                      product?.title
                                    );
                                  }}
                                  value={dropdown?.selectedValue}
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  IconComponent={() => (
                                    <img
                                      src={Arrow} // Path to your PNG icon in the public directory
                                      alt="Custom Arrow"
                                      style={{
                                        width: "12px",
                                        height: "6.4px",
                                        marginRight: 20,
                                        position: "absolute",
                                        right: 0
                                      }} // Adjust the size as needed
                                    />
                                  )}
                                  MenuProps={menuProps}
                                  classes={{
                                    select: classes.select,
                                    icon: classes.selectIcon
                                  }}
                                >
                                  <MenuItem disabled value="">
                                    <em>Select</em>
                                  </MenuItem>
                                  {varients?.[productIndex]?.variantsInfo?.map(
                                    (option, index) => (
                                      <MenuItem
                                        key={index}
                                        value={option?.option}
                                        disabled={
                                          (product?.type !== "onRegistration" &&
                                            !option?.infiniteQuantity &&
                                            (option?.quantity -
                                              (option?.reserveProduct || 0) <=
                                              0 ||
                                              option?.counterValue >=
                                                option?.quantity -
                                                  (option?.reserveProduct ||
                                                    0))) ||
                                          (option?.forMemberOnly && !isAuth) ||
                                          (option?.openAmount && option?.counterValue >= 1)
                                        }
                                        className="d-flex align-items-center justify-content-between "
                                        style={{
                                          flexDirection: "row",
                                          padding: "10px"
                                        }}
                                      >
                                        <div
                                          className="d-inline-flex "
                                          style={{
                                            gap: "5px"
                                          }}
                                        >
                                          <span> {option?.option} </span>
                                          <span>
                                            {" "}
                                            {option?.forMemberOnly &&
                                              !isAuth && (
                                                <span>(Members Only)</span>
                                              )}
                                          </span>
                                        </div>
                                        <span
                                          style={{
                                            marginLeft: "5px"
                                          }}
                                        >
                                          {option?.openAmount
                                            ? option?.minimumOpenAmount
                                              ? `Min: ${numberFormat({ number: option.minimumOpenAmount, decimal: 2, style: "currency" })}`
                                              : "Open Amount"
                                            : numberFormat({
                                                number: option?.amount,
                                                decimal: 2,
                                                style: "currency"
                                              })}
                                        </span>
                                      </MenuItem>
                                    )
                                  )}
                                </Select>
                              </SelectWrapper>
                              {dropdownIndex !==
                                product.dropdowns.length - 1 && (
                                <hr
                                  style={{
                                    border: "none",
                                    borderTop: "1px solid #E5E7EB",
                                    margin: "12px 0"
                                  }}
                                />
                              )}
                            </>
                          );
                        })}
                      </FormControl>
                    )}

                  <Amount
                    style={{
                      marginTop: product.type === "openAmount" ? "0px" : "",
                      width: product.type === "openAmount" ? (isDesktop ? "200px" : "100%") : ""
                    }}
                  >
                    {product.type === "openAmount" && product.counter > 0 ? (
                      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        {editingAmount[productIndex] ? (
                          <div style={{ position: "relative", width: "100%", height: 48 }}>
                            <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: Fonts.GeneralSubHeaderFont.fontSize, fontWeight: Fonts.GeneralSubHeaderFont.fontWeight, color: FontColors.Blue2555EF, pointerEvents: "none" }}>
                              {currency}
                            </span>
                            <input
                              autoFocus
                              type="number"
                              value={formik?.values?.productsOpenAmount?.[productIndex] ?? minAmountProduct}
                              onChange={e => {
                                const value = e.target.value;
                                if (Number(value) > 1000000) return;
                                formik.setFieldValue(`productsOpenAmount.${productIndex}`, value);
                                if (product.counter > 0) addPriceToObjects(e, product._id, product.title);
                                if (Number(value) < minAmountProduct) {
                                  setAmountErrors(prev => ({ ...prev, [`product-${productIndex}`]: `Minimum amount is ${minAmountProduct}` }));
                                } else {
                                  setAmountErrors(prev => ({ ...prev, [`product-${productIndex}`]: "" }));
                                }
                              }}
                              onKeyDown={e => { if (e.key === "Enter") e.target.blur(); preventMinus(e, e.target.value); }}
                              onBlur={() => setEditingAmount(prev => ({ ...prev, [productIndex]: false }))}
                              style={{ width: "100%", height: 48, boxSizing: "border-box", border: "2px solid #2555EF", borderRadius: 12, paddingLeft: 34, paddingRight: 14, fontSize: Fonts.GeneralHeaderFont.fontSize, fontWeight: Fonts.GeneralHeaderFont.fontWeight, color: FontColors.Blue002E5C, background: "#fff", outline: "none", textAlign: "right", boxShadow: "0 2px 12px rgba(37,85,239,0.12)", WebkitAppearance: "none", appearance: "none" }}
                            />
                          </div>
                        ) : (
                          <div
                            onClick={() => setEditingAmount(prev => ({ ...prev, [productIndex]: true }))}
                            style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", background: "#fff", borderRadius: 12, padding: "11px 14px", cursor: "pointer", boxShadow: "0 2px 8px rgba(37,85,239,0.08)" }}
                          >
                            <span style={{ fontSize: Fonts.GeneralSubHeaderFont.fontSize, fontWeight: Fonts.GeneralSubHeaderFont.fontWeight, color: FontColors.Blue002E5C }}>
                              {currency}{Number(formik?.values?.productsOpenAmount?.[productIndex] ?? minAmountProduct).toFixed(2)}
                            </span>
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2555EF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                            </svg>
                          </div>
                        )}
                        {amountErrors[`product-${productIndex}`] && (
                          <div style={{ color: FontColors.Red, fontSize: Fonts.GeneralCaptionFont.fontSize, marginTop: 4 }}>{amountErrors[`product-${productIndex}`]}</div>
                        )}
                      </div>
                    ) : (
                      product.type !== "openAmount" && product?.limitType !== "checkbox" && (
                        <div
                          style={{
                            marginRight:
                              product.type !== "openAmount" && !product?.variant
                                ? window.innerWidth > 767
                                  ? "54px"
                                  : 0
                                : 0
                          }}
                        >
                          {" "}
                          {!product?.variant &&
                            `${numberFormat({
                              number: product?.amount,
                              decimal: 2,
                              style: "currency"
                            })}`}
                        </div>
                      )
                    )}
                  </Amount>
                </SecondDiv>
              </ProductContent>
              <SolidLine />
            </>
          );
        })}
      </Wrapper>
    );
  }
);
